import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import HomeBox from './homeBox';
import FoodBox from './foodBox';

class HFNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        listOne: PropTypes.string,
        listTwo: PropTypes.string,
        isGZ: PropTypes.bool,
    };

    render() {
        const {
            content: { homeData, foodData, pitAndFoodAd },
            listOne,
            listTwo,
            isGZ,
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <HomeBox content={homeData} listOne={listOne} listTwo={listTwo} isGZ={isGZ} />
                    <FoodBox content={foodData} />
                </div>
                {pitAndFoodAd ? <Ad content={pitAndFoodAd} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(HFNews);
